import { dismissExpenseMoveFailures, recoverExpenseMoves } from "@/lib/expense_move";
import { reportMoveRecoveryFailures, type SyncStatus } from "@/lib/sync";

export function useMoveRecovery(status: Pick<SyncStatus, "moveRecoveryFailures">) {
  return {
    hasMoveFailures: (status.moveRecoveryFailures ?? 0) > 0,
    dismissMoveFailures: async () => {
      await dismissExpenseMoveFailures();
      reportMoveRecoveryFailures(await recoverExpenseMoves());
    },
  };
}
